
// cn.js
export default {
  home: {
    about: '关于我们',
    more:'查看更多'
  }
}